import { Key, ReactElement } from "react";

export type Option<T extends Key = string, TMeta = unknown> = {
  value: T;
  label: ReactElement | number | string;
  meta?: TMeta;
};

export const compare = <T extends Key, TMeta>(a: Option<T, TMeta>, b: Option<T, TMeta>): boolean =>
  a?.value === b?.value;
